import React from 'react'
import clsx from 'clsx'

import FalseIcon from '@/assets/icons/false.svg'
import TrueIcon from '@/assets/icons/true.svg'
import * as styles from './ListWithBool.module.css'
import { ListWithBoolTypes } from './types'

export function ListWithBool({ list_items }: ListWithBoolTypes) {
  return (
    <div className="flex flex-col w-4/12 tablet:w-1/6">
      {list_items?.length &&
        list_items.map((item, index) => (
          <>
            <p
              className={clsx(
                index !== 0 && 'invisible tablet:visible',
                'font-poppins font-bold text-xl h-80 pl-32 flex items-center justify-center text-text-dark-900'
              )}
            >
              {item.title}
            </p>
            {item.bool_blocks.map(({ bool_value, _uid }) => (
              <div key={_uid} className={clsx('flex items-center justify-center h-80 pl-32', styles.list)}>
                <p className="font-poppins text-bodyM">
                  {bool_value ? <img src={TrueIcon} alt="enabled" /> : <img src={FalseIcon} alt="disabled" />}
                </p>
              </div>
            ))}
          </>
        ))}
    </div>
  )
}
